import React from 'react'
import BaseQueryControlComponent from './BaseQueryControlComponent'
import Immutable from 'immutable'
import {makeGrids} from '../../helpers/makeGrids.js'
import FieldComponent from './FieldComponent'
import {Button, ButtonGroup} from 'react-bootstrap'
import {t} from '../../helpers/translate'
import _ from 'lodash';
import $ from 'jquery';
let config = require('config');

class ReportboxComponent extends BaseQueryControlComponent {

  constructor(props) {
    super(props);
    this.state = {
      data: Immutable.Map(this.props.criteria)
    }
  }

  handleDataChange(delta) {
    this.setState({
      data: this.state.data.setIn(delta.key_path, delta.value)
    })
  }

  showReportForm() {
    let searchParameters = config.default.reports['policies']['ingle'];
    searchParameters[0].options = this.props.sources;

    let elems = searchParameters.map(
      (field, index) =>
        <div key={index}>
          <label className="text-uppercase">{field.as}</label>
          <div>
            <FieldComponent
              type={field.type}
              keyPath={[field.key]}
              format={field.format}
              onDataChanged={this.handleDataChange.bind(this)}
              minDate={field.min_date}
              maxDate={field.max_date}
              options={field.options}
              id={`${field.key}`}
              hideNullOption={field.hideNullOption}
              defaultValue={field.defaultValue}
              {...this.state}
            />
          </div>
        </div>
    );
    return makeGrids(2, elems);
  }

  getCriteriaKeys() {
    return config.default.reports['policies']['ingle'].map((field) => field.key)
  }

  validateData(query) {
  }

  submitText() {
    let query = this.getUpdatedQuery(this.state.data.toObject(), this.getCriteriaKeys());
    query.page = 1;
    this.updateSearchString(query);
  }

  getCleanedObject(object) {
    let keys = this.getCriteriaKeys();
    let inputs = $('#criteria-form').find('input[type=text]');
    let values = inputs.toArray().map((input) => input.value);
    for (let i = 0; i < inputs.length; i++) {
      if (_.isEmpty(values[i])) {
        delete object[keys[i]]
      }
    }
    return object;
  }

  render() {
    return <div id="criteria-form">
      {this.showReportForm()
      }
      <br />
      <div className="div-center">
        <Button className="btn btn-lg button-secondary" onClick={this.submitText.bind(this)}>{t('Send Report')}</Button>
      </div>
    </div>
  }
}
ReportboxComponent.displayName = 'ReportboxComponent';
export default ReportboxComponent;



// WEBPACK FOOTER //
// ./src/components/common/ReportboxComponent.js